<table>
  <thead>
    <tr>
      <th *ngFor="let column of columnDefs" [attr.data-field]="column.field">
        {{column.label}}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rowData;  index as rowIndex" class="tr-row-{{rowIndex}}">
      <td *ngFor="let column of columnDefs; index as columnIndex; last as isLast" class="td-column-{{columnIndex}} column-data {{column.class}}">
        <div class="selector"></div>

        <input [(ngModel)]="rowData[rowIndex][column.field]"
               [ngModelOptions]="{standalone: true}"
               (keydown)="onKeyUp($event, rowIndex, columnIndex)"
               [autocomplete]="column.field"
               (focus)="addCellFocusClass(rowIndex, columnIndex)">

        <ng-container *ngIf="isLast">
          <i class="material-icons remove" (click)="removeRow(rowIndex)" *ngIf="rowData.length > 1">remove_circle_outline</i>
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
